module.exports = __webpack_public_path__ + "media/images/badge/stratega_secondary-2898e0aa18d551047b6e69224dd8eeaf.png";